import { useRouter } from 'next/router';
import { InferGetStaticPropsType } from 'next';
import { Layout, MultiFilteredCollectionView } from '@components';
import { withLocalizedPaths } from '@utils/locales';
import { BASE_FRAME_NAMES, getBasePLPProps, handleProductPathRedirects } from '@utils/index';

const Eyeglasses = ({
	collection,
	hero,
	interactiveCards,
	seoMetadata,
	isBFSet,
	additionalInformation,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
	const router = useRouter();
	const { demo } = router.query as { demo: string };
	const pathInfo = `/eyeglasses/${demo}`;

	if (!isBFSet) {
		collection = {
			...collection,
			products: collection.products.filter(product => {
				// Removes "The" article from product name
				const baseFrameName = product.name.split(' ')[1];
				return BASE_FRAME_NAMES.includes(baseFrameName);
			}),
		};
	}

	return (
		<MultiFilteredCollectionView
			baseType='Eyeglasses'
			hero={hero}
			demo={demo}
			collection={collection}
			pathInfo={pathInfo}
			interactiveCards={interactiveCards}
			showVTO
			seoMetadata={seoMetadata}
			additionalInformation={additionalInformation}
		/>
	);
};

export const getStaticPaths = withLocalizedPaths(async () => {
	return {
		paths: [],
		fallback: 'blocking',
	};
});

export async function getStaticProps({ locale, params: { demo } }) {
	const redirectedProductPaths = handleProductPathRedirects(demo, locale, 'eyeglasses');

	if (redirectedProductPaths) return redirectedProductPaths;
	const plpProps = await getBasePLPProps({ category: 'eyeglasses', demo, locale });

	if (!plpProps) {
		console.error(`SSG error in /eyeglasses/${demo}.`);
		return {
			notFound: true,
			revalidate: 600,
		} as const;
	}

	return {
		props: {
			key: demo,
			...plpProps,
			locale,
			background: 'gray0',
		},
	};
}

Eyeglasses.getLayout = function getLayout(page, pageProps) {
	return <Layout pageProps={pageProps}>{page}</Layout>;
};

export default Eyeglasses;
